// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"e85cdc50","602":"747197b8","634":"fc5afa4a","733":"fc5afa4a","799":"43f64c11"}[chunkId] + ".chunk.css";
};